import React from 'react'
import { oneOf } from 'prop-types'
import { CallToAction, Heading } from '@scentregroup/ui'
import ExternalLink from '../external-link'
import style from './index.scss'

const SUBSCRIBE_AU = 'https://account.westfield.com.au/subscribe'
const SUBSCRIBE_NZ = 'https://account.westfield.co.nz/subscribe'

const NewsletterSubscribe = ({ country }) => (
  <div className={style.subscribeSection}>
    <Heading type="small" className={style.subscribeHeading}>
      Keep up to date with everything Westfield
    </Heading>
    <CallToAction
      inverted
      fullWidth
      element={ExternalLink}
      url={country === 'New Zealand' ? SUBSCRIBE_NZ : SUBSCRIBE_AU}
      data-test-id="subscribe-button"
    >
      Subscribe
    </CallToAction>
  </div>
)

NewsletterSubscribe.propTypes = {
  country: oneOf(['Australia', 'New Zealand']).isRequired,
}

export default NewsletterSubscribe
